import { LayerDefinition } from './types';

export const liveRadarDefinition: LayerDefinition = {
  id: 'live_weather_radar',
  name: 'NOAA Doppler Radar',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '🌧️',
  description: 'High-resolution real-time composite radar reflectivity from NOAA Multi-Radar Multi-Sensor (MRMS) network, updated every 2-5 minutes.',
  sourceModels: ['NOAA MRMS (Multi-Radar Multi-Sensor) Composite Reflectivity'],
  outputModels: ['Real-time seamless WebGL tile loops (1h, 2h, 4h history)']
};

export const liveLightningDefinition: LayerDefinition = {
  id: 'live_weather_lightning',
  name: 'Lightning Strikes (8h Decay & Density)',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '⚡',
  description: 'Real-time NOAA MRMS / NLDN 5-minute cloud-to-ground lightning strikes aggregated onto 4.4 km cells over a rolling 8-hour trail, decaying from vivid electric yellow (0-5 min) to slate gray (8h) and scaled by peak flash density and zoom level.',
  sourceModels: ['NOAA MRMS / NLDN National Lightning Detection Network (5-min CG AvgDensity)'],
  outputModels: ['Rolling 8-hour 5-min vector lightning trail (mrms_lightning_history.json)']
};

export const liveSatelliteDefinition: LayerDefinition = {
  id: 'live_weather_satellite',
  name: 'Geostationary Satellite Imagery',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '🛰️',
  description: 'High-frequency visible and infrared (IR) satellite imagery loops observing real-time cloud movement, marine fog, and atmospheric convection.',
  sourceModels: ['NOAA GOES-East (GOES-16)', 'NOAA GOES-West (GOES-18)', 'JMA Himawari-9', 'EUMETSAT Meteosat-9/10'],
  outputModels: ['Georeferenced visual & infrared tile loops']
};

export const liveQpeDefinition: LayerDefinition = {
  id: 'live_weather_qpe',
  name: 'Rain Accumulation (Past 1/24/72 Hrs)',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '🌧️',
  description: 'Observed real-time Quantitative Precipitation Estimation (QPE) showing actual rainfall accumulated over the past 1, 24, or 72 hours calibrated from NOAA MRMS radar reflectivity and surface rain gauges (not a forecast).',
  sourceModels: ['NOAA MRMS Multi-Sensor Gauge-Adjusted QPE'],
  outputModels: ['1-Hour, 24-Hour, and 72-Hour Precipitation Grids']
};

export const liveSnowDefinition: LayerDefinition = {
  id: 'live_weather_snow',
  name: 'Snow Accumulation (Past 24/48/72 Hrs)',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '❄️',
  description: 'Observed real-time snowfall accumulation showing actual snowfall that has fallen over the past 24, 48, or 72 hours calibrated from NOAA MRMS radar and surface weather stations (not a forecast).',
  sourceModels: ['NOAA MRMS Snowfall Accumulation Product'],
  outputModels: ['24h, 48h, and 72h Snowfall Grids']
};

export const liveRtmaWindsDefinition: LayerDefinition = {
  id: 'winds_surface_current',
  name: 'Current Surface Winds (RTMA)',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '💨',
  description: 'Real-time surface wind speed and vector streamline observations derived from NOAA Real-Time Mesoscale Analysis (RTMA).',
  sourceModels: ['NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)'],
  outputModels: ['Real-time wind vector streamlines and velocity tiles']
};

export const liveRtmaTempDefinition: LayerDefinition = {
  id: 'hrtemp_current',
  name: 'Current Temperature (RTMA)',
  category: 'live_weather',
  categoryLabel: 'Real-Time Observation',
  icon: '🌡️',
  description: 'Real-time surface temperature observations derived from NOAA Real-Time Mesoscale Analysis (RTMA 2.5km).',
  sourceModels: ['NOAA RTMA (Real-Time Mesoscale Analysis 2.5km)'],
  outputModels: ['Real-time 2.5km surface temperature .pmtiles']
};
